import * as React from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import "../data-source/CreateDataSource.css";
import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import Card, {
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/bootstrap/Card";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Button from "../../../components/bootstrap/Button";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import Checks from "../../../components/bootstrap/forms/Checks";
import CustomScrollbar from "../../../components/bootstrap/CustomScrollbar";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";
import ToastComponent from "../../../components/ToastComponent";

export default function CreateGroup() {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const form = useForm<FormValues>();
  const { handleSubmit } = form;
  const [users, setUsers] = React.useState<any[]>([]);
  const [usersDuplicate, setUsersDuplicate] = React.useState<any[]>([]);
  const [selectedUsers, setSelectedUsers] = React.useState<any[]>([]);
  const [show, setShow] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [successMessage, setSuccessMessage] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [searchInput, setSearchInput] = React.useState<string>("");
  const [formData, setFormData] = React.useState<FormValues>({
    name: "",
    users: [],
  });
  const location = useLocation();

  type FormValues = {
    name: string;
    users: any[];
  };
  const addOrRemoveUsersToGroupOnCheckboxChange = (event: any) => {
    const { checked, value } = event.currentTarget;
    setSelectedUsers((prev: any) =>
      checked ? [...prev, value] : prev.filter((val: any) => val !== value)
    );
  };
  const getAllUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${vyu_api_url}/user/allUser`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setUsers(data);
        setUsersDuplicate(data);
      }
    } catch (e) {}
  };
  React.useEffect(() => {
    getAllUsers();
  }, []);

  // Load form data on mount
  React.useEffect(() => {
    const savedFormData = localStorage.getItem("groupsFormData");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }
  }, []);

  // Save form data on change
  React.useEffect(() => {
    localStorage.setItem("groupsFormData", JSON.stringify(formData));
  }, [formData]);

  // Clear localStorage if leaving groups section
  React.useEffect(() => {
    return () => {
      if (!location.pathname.startsWith("/groups")) {
        localStorage.removeItem("groupsFormData");
      }
    };
  }, [location.pathname]);

  const saveGroup = async () => {
    // console.log(JSON.stringify(formData))
    const token = localStorage.getItem("token");
    const formDataObject = {
      groupName: capitalizeAllLetter(formData.name),
      userIdList: selectedUsers,
    };
    // console.log(formDataObject)
    try {
      const response = await fetch(`${vyu_api_url}/groups/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formDataObject),
      });
      if (response.ok) {
        setSuccessMessage("Group created successfully!");
        handleSuccess("Group created successfully!");
      } else {
        const data = await response.json();
        setErrorMessage(data.message || "Failed to create Group!");
        handleError(data.message || "Failed to create role!");
      }
    } catch (error) {
      console.error("Error creating Group:", error);
      setErrorMessage("An error occurred while creating Group");
    }
    handleFullReset();
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    // console.log(name,'-->',value)
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleReset = () => {
    setFormData({
      name: "",
      users: [],
    });
    setDisabled(true);
    setShow(false);
  };
  const handleFullReset = () => {
    setFormData({
      name: "",
      users: [],
    });
    setDisabled(true);
    setShow(false);
  };
  const onSubmit = () => {
    saveGroup();
  };
  const handleCheckBox = async () => {
    try {
      setDisabled(false);
      setShow((prev) => !prev);
    } catch (e) {
      console.error(e);
    }
  };
  function handleSearchInput1Change(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    const val = event.target.value;
    setSearchInput(val);
    let allUsers = usersDuplicate;
    let filteredUsers = allUsers.filter(
      (item) =>
        item.firstName.toLowerCase().startsWith(val.toLowerCase()) ||
        item.lastName.toLowerCase().startsWith(val.toLowerCase())
    );
    setUsers(filteredUsers);
  }
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };
  return (
    <>
      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          {/* <CardHeader>
            <Breadcrumb
              list={[
                { title: "Groups", to: "" },
                { title: "Create Group", to: "" },
              ]}
            />
          </CardHeader> */}

          <CardBody>
            <div className="col-lg-6 mb-4">
              <FormGroup label="Group Name">
                <Input
                  id="name"
                  name="name"
                  style={smallRadius}
                  className={inputStyle}
                  placeholder="Enter name of the Group"
                  value={formData.name}
                  onChange={handleChange}
                />
              </FormGroup>
            </div>

            <div className="col-lg-6  mb-4">
              <FormGroup label="Add users to group?">
                <Checks
                  //   disabled={disabled}
                  className="rounded-lg bg-black"
                  onChange={handleCheckBox}
                  checked={show}
                  type="checkbox"
                  aria-label="pr"
                />
              </FormGroup>
              {show && (
                <Card stretch style={{ borderRadius: "4px" }}>
                  <CardBody>
                    <div className="mb-1 mt-3">
                      <Input
                        type="text"
                        placeholder="Search..."
                        style={smallRadius}
                        className={inputStyle}
                        value={searchInput}
                        onChange={handleSearchInput1Change}
                      />
                    </div>
                    <CustomScrollbar height="200px">
                      {users.map((item) => (
                        <div className="m-2" key={item.userId}>
                          <input
                            key={item.userId}
                            value={item.userId}
                            type="checkbox"
                            className="custom-checkbox p-1"
                            defaultChecked={selectedUsers.some(
                              (val) => val === item.userId
                            )}
                            // onChange={addUserToGroup}
                            // checked={selectedUsers.some(val => val === item.id)}
                            onChange={addOrRemoveUsersToGroupOnCheckboxChange}
                          />
                          <label className="m-2">
                            {item.firstName + " " + item.lastName}
                          </label>
                        </div>
                      ))}
                    </CustomScrollbar>
                  </CardBody>
                </Card>
              )}
            </div>
          </CardBody>
          <CardFooter>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
              }}
            >
              <form
                onSubmit={handleSubmit(onSubmit)}
                // className="w-full  flex items-center justify-center"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                  // border: "1px solid black",
                }}
              >
                <Button
                  isLight={true}
                  color="primary"
                  // className="basis-1/2 m-1 text-black italic bg-violet-200  hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100"
                  className="submit-reset"
                  style={{ border: "1px solid #d0d5dd" }}
                  type="button"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button
                  type="submit"
                  isLight={true}
                  color="primary"
                  className="submit-button"
                >
                  Submit
                </Button>
              </form>
            </div>
          </CardFooter>
        </Card>
        <ToastComponent />
      </div>
    </>
  );
}
